import { render, staticRenderFns } from "./management-platform-roadmap-view.vue?vue&type=template&id=f0aaf7a8"
import script from "./management-platform-roadmap-view.vue?vue&type=script&lang=js"
export * from "./management-platform-roadmap-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports